import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    payrollList: {
      requesting: false,
      items: [],
      pagination: {
		  current_page: 1,
		  per_page: 10,
		  total: 0,
	  },
      errors: null,
      success: false,
      filters: {},
    },
    payrollDetails: {
      requesting: false,
      errors: null,
      success: false,
      data: null,
    },
  };

export const payrollSlice = createSlice({
  name: 'payroll',
  initialState,
  reducers: {
    getPayrollList: (state, action) => {
        state.payrollList.requesting = true;
        state.payrollList.errors = null;
        state.payrollList.items = [];
        state.payrollList.success = false;
        state.payrollList.filters = action.payload;
    },
    getPayrollListSuccess: (state, action) => {
		const { data, current_page, per_page, total} = action.payload;
        state.payrollList.requesting = false;        
        state.payrollList.items = data;
        state.payrollList.success = true; 
        state.payrollList.pagination.current_page = current_page;
        state.payrollList.pagination.per_page = per_page;
        state.payrollList.pagination.total = total;
    },
    getPayrollListFail: (state, action) => {        
        state.payrollList.requesting = false;
        state.payrollList.errors = action.payload;
    },
    getPayrollDetails: (state) => {
        state.payrollDetails.requesting = true;
        state.payrollDetails.errors = null;
        state.payrollDetails.data = null;
        state.payrollDetails.success = false; 
    },
    getPayrollDetailsSuccess: (state, action) => {
        state.payrollDetails.requesting = false;
        state.payrollDetails.data = action.payload;
        state.payrollDetails.success = true; 
    },
    getPayrollDetailsFail: (state, action) => {        
        state.payrollDetails.requesting = false;
        state.payrollDetails.errors = action.payload;
    },
    doPayrollCreate: (state) => {
        state.payrollDetails.requesting = true;
        state.payrollDetails.errors = null;
        state.payrollDetails.success = false; 
    },
    doPayrollUpdate: (state) => {
        state.payrollDetails.requesting = true;
        state.payrollDetails.errors = null;
        state.payrollDetails.success = false; 
    },
    doPayrollDelete: (state) => {
        state.payrollDetails.requesting = true;
        state.payrollDetails.errors = null;
        state.payrollDetails.data = null;
        state.payrollDetails.success = false; 
    },
    doPayrollProgressUpdate: (state) => {
        state.payrollDetails.requesting = true;
        state.payrollDetails.errors = null;
        state.payrollDetails.success = false; 
    },
  },
})

export const { 
    getPayrollList, getPayrollListSuccess, getPayrollListFail,
    getPayrollDetails, getPayrollDetailsSuccess, getPayrollDetailsFail,
    doPayrollCreate, doPayrollUpdate, doPayrollDelete,
    doPayrollProgressUpdate
} = payrollSlice.actions

export default payrollSlice.reducer